import { Link as i } from "@box/blueprint-web";
import o from "clsx";
import { s as a } from "../../../chunks/hyperlink-popover.module.js";
import { jsxs as s, jsx as e, Fragment as m } from "react/jsx-runtime";

var p = function p(_ref) {
  var t = _ref.url,
      r = _ref.children;
  return /* @__PURE__ */s("div", {
    className: a.readState,
    children: [/* @__PURE__ */e(i, {
      className: o(a.clickableLink, a.important),
      "data-testid": "hyperlink-link",
      href: t,
      target: "_blank",
      children: t
    }), !!r.some(Boolean) && /* @__PURE__ */s(m, {
      children: [/* @__PURE__ */e("div", {
        className: a.separator
      }), /* @__PURE__ */e("div", {
        className: a.readStateButtons,
        children: r
      })]
    })]
  });
};

export { p as ReadLink };